@if (flow.isOpen) {
  <app-confirm-action-modal
    title="Move to own number"
    [confirmLabel]="flow.step === 'phone' ? 'Continue' : 'Move plate'"
    [busyLabel]="flow.step === 'phone' ? 'Checking...' : 'Moving...'"
    cancelButtonClass="btn-outlined"
    [busy]="flow.busy"
    [confirmDisabled]="flow.step === 'phone' ? !flow.canLookUp : !flow.canMove"
    [closeOnOverlayClick]="false"
    [mobileSheet]="false"
    testId="family-move-modal"
    (confirm)="flow.step === 'phone' ? flow.lookUp() : flow.move()"
    (cancel)="flow.close()"
  >
    <div class="move">
      <p class="move__text" data-testid="move-text">
        Give <strong>{{ plate }}</strong> a phone number of its own. The membership then shows under
        that contact and in their app.
      </p>

      @if (flow.step === 'phone') {
        <div class="form-group">
          <label for="move-phone">Member's phone number</label>
          <input
            id="move-phone"
            type="tel"
            class="form-control"
            maxlength="20"
            data-testid="move-phone"
            [(ngModel)]="flow.phone"
            [disabled]="flow.busy"
            (keydown.enter)="flow.lookUp()"
          />
        </div>
      } @else {
        <p class="move__text" data-testid="move-customer">
          Number ending {{ flow.preview?.phone_last4 }}
          @if (flow.preview?.customer?.exists) {
            · existing customer <strong>{{ flow.preview?.customer?.name }}</strong>
          } @else {
            · no customer yet
          }
          <button
            type="button"
            class="move__link"
            data-testid="move-edit-number"
            [disabled]="flow.busy"
            (click)="flow.editNumber()"
          >
            Change
          </button>
        </p>

        @if (flow.asksName) {
          <div class="move__names">
            <div class="form-group">
              <label for="move-first-name">First name</label>
              <input
                id="move-first-name"
                type="text"
                class="form-control"
                data-testid="move-first-name"
                [(ngModel)]="flow.firstName"
                [disabled]="flow.busy"
              />
            </div>
            <div class="form-group">
              <label for="move-last-name">Last name</label>
              <input
                id="move-last-name"
                type="text"
                class="form-control"
                data-testid="move-last-name"
                [(ngModel)]="flow.lastName"
                [disabled]="flow.busy"
              />
            </div>
          </div>
        }

        <p class="move__text" data-testid="move-billing">
          The plate stays in the family and keeps billing the primary's card.
        </p>
      }

      @if (flow.error) {
        <p class="move__error" role="alert" data-testid="move-error">{{ flow.error }}</p>
      }
    </div>
  </app-confirm-action-modal>
}
